import { createApp, pinia } from './vue';

import stepsCarousel from './vue/apps/steps-carousel';

const stepsCarouselMountingContainer = document.querySelectorAll('.js-steps-carousel-container');

if (stepsCarouselMountingContainer) {
    const stepsCarousels = [];

    stepsCarouselMountingContainer.forEach((el) => {
        const app = createApp(stepsCarousel).use(pinia).mount(el);
        stepsCarousels.push(app);
    });
}
